import { registerLicense } from "@syncfusion/ej2-base";
import { CookiesProvider } from "react-cookie";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import NotFound from './component/NotFound.jsx';
import "./links.jsx";
import { AuthProvider } from "./pages/auth/AuthContext";
import { store } from "./redux/store/store.js";
import { publicRoutes } from "./Routes/PublicRoutes.jsx";
import { ClubRoutes } from "./Routes/ClubRoutes.jsx";
import { coachRoutes } from "./Routes/CoachRoutes.jsx";
import { paymentRoutes } from "./Routes/PaymentRoutes.jsx";
import { commonRoutes } from "./Routes/CommonRoutes.jsx";
import { APIProvider } from "@vis.gl/react-google-maps";
import { ThemeProvider } from "./theme/ThemeContext";



const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      ...publicRoutes,
      ...ClubRoutes,
      ...coachRoutes,
      ...paymentRoutes,
      ...commonRoutes,
      { path: '*', element: <NotFound /> }
    ],
  },
]);

registerLicense(import.meta.env.VITE_APP_SYNCFUSION_LICENSE);
createRoot(document.getElementById("root")).render(
  // <StrictMode>
  <Provider store={store}>
    <ThemeProvider>
      <AuthProvider>
      <CookiesProvider>
          <APIProvider apiKey={import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY} libraries={['places']}>
            <RouterProvider router={router} />
          </APIProvider>
        </CookiesProvider>
      </AuthProvider>
    </ThemeProvider>
  </Provider>
  // </StrictMode>
);